import {trigger} from "../../utils/events/trigger";
import {SIDEBAR} from "../constants";

export const initInputStateSwitch = () => {
	const elements = Array.from(document.querySelectorAll(`.state-switch`));
	
	if ( elements )
	{
		elements.forEach((element) => element.checked ? element.checked = true : element.checked = false);

		const SITE_MENU = document.querySelector(`input[id="state-switch"]`);
		const HEADER = document.querySelector(`header`);
		const NAVIGATION = HEADER.querySelector(`nav ul`);
		
		let currentScrollPosition = 0;

		const setPageStyles = () => {
			currentScrollPosition = window.pageYOffset;
			document.documentElement.style = `overflow: hidden;`;
			document.body.style = `overflow: hidden; width: 100%; position: fixed; top: ${currentScrollPosition * -1}px; left: 0;`;
			HEADER.style = `position: fixed;`;
		};
		
		const removePageStyles = () => {
			document.documentElement.style = ``;
			document.body.style = ``;
			HEADER.style = ``;
			window.scrollTo(0, currentScrollPosition);
		};
		
		SITE_MENU.addEventListener(`change`, function () {
			if ( this.checked )
			{
				setPageStyles();
				HEADER.style.zIndex = `999999`;
				NAVIGATION.style.paddingBottom = `${Math.abs(window.innerHeight - HEADER.offsetHeight - NAVIGATION.offsetHeight) + 4 * 14}px`;
				return;
			}

			removePageStyles();
			NAVIGATION.style = ``;
		});

		SIDEBAR.INPUT.addEventListener(`change`, function () {
			if ( this.checked )
			{
				setPageStyles();
				SIDEBAR.isOpened = true;
				return;
			}

			removePageStyles();
		});
	}
};
